// extracted by mini-css-extract-plugin
module.exports = {"section":"app_section__T7JZo","fcontainer":"app_fcontainer__o0gTH","flag":"app_flag__5D9TT"};